<section class="airdrop" id="early-access">
    <div class="airdrop__container">
        <!-- ── Section Header ─────────────────────────────────────────── -->
        <div class="airdrop__header">
            <h2 class="airdrop__title" [innerHTML]="'airdrop.title' | translate"></h2>
            <p class="airdrop__description">{{ 'airdrop.description' | translate }}</p>
        </div>

        <!-- @if (!walletAddress) {  (click)="showWidget()"-->
        <button class="btn btn-primary px-4">{{ 'airdrop.join_platform' | translate }}</button>
        <!-- } -->
        @if (walletAddress) {
        <div class="subscribe-wrap w-100 mwx-450">
            <div class="tags">
                <div class="d-flex align-items-center w-100 gap-2">
                    <div class="border-wrap flex-grow-1">
                        <input type="text" class="airdrop__input" placeholder="Enter Your Email Address" [(ngModel)]="email">
                    </div>
                    <button class="btn btn-primary font-14" (click)="subscribe()">{{"airdrop.subscribe_now" |
                        translate}}</button>
                </div>
                <!-- <p class="text-primary fw-medium mt-1 mb-0 font-10 text-center">{{"airdrop.terms_condition" | translate}}</p> -->
                <div class="text-danger mt-1 font-12" *ngIf="emailError">{{ emailError }}</div>
                <div class="text-success mt-1 font-12" *ngIf="successMessage">{{ successMessage }}</div>
            </div>
        </div>
        }
    </div>
</section>